var React = require('react');

function QuoteMarks (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.46649 32C0.822163 27.3655 0 22.731 0 18.0965C0 12.7264 1.35836 8.38621 4.07507 5.07586C6.86327 1.69196 10.9383 0 16.3003 0V7.83448C12.5112 7.83448 10.6166 10.446 10.6166 15.669V17.1034H17.8016V32H2.46649ZM24.6649 32C23.0206 27.5862 22.1984 22.9517 22.1984 18.0965C22.1984 12.7264 23.5567 8.38621 26.2735 5.07586C29.0617 1.69196 33.1367 0 38.4987 0V7.83448C34.6381 7.83448 32.7078 10.446 32.7078 15.669V17.1034H40V32H24.6649Z"}));
}

QuoteMarks.defaultProps = {"width":"40","height":"32","viewBox":"0 0 40 32","fill":"currentColor"};

module.exports = QuoteMarks;

QuoteMarks.default = QuoteMarks;
